// extracted by mini-css-extract-plugin
export default {"zoomControls":"Vaa-z","zoomControlButton":"Waa-z","zoomBanner":"Xaa-z","bannerButton":"Yaa-z","imageButton":"Zaa-z","zoom":"_aa-z","zoomContent":"aba-z"};